"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _inputValidationMessage = _interopRequireDefault(require("../input-validation-message"));
var _floatLabel = _interopRequireDefault(require("../float-label"));
var _ripple = _interopRequireDefault(require("../ripple"));
require("./field-base.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * A form field wrapper with floating labels.
 */
var FieldBase = function FieldBase(_ref) {
  var childId = _ref.childId,
    children = _ref.children,
    className = _ref.className,
    childWrapperClassName = _ref.childWrapperClassName,
    containerProps = _ref.containerProps,
    customFieldStatus = _ref.customFieldStatus,
    _ref$enableValidation = _ref.enableValidationMessage,
    enableValidationMessage = _ref$enableValidation === void 0 ? true : _ref$enableValidation,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    errorMessageDisplayStatus = _ref.errorMessageDisplayStatus,
    floatLabelActive = _ref.floatLabelActive,
    floatLabelActiveText = _ref.floatLabelActiveText,
    _ref$floatLabelAriaHi = _ref.floatLabelAriaHidden,
    floatLabelAriaHidden = _ref$floatLabelAriaHi === void 0 ? false : _ref$floatLabelAriaHi,
    floatLabelClassName = _ref.floatLabelClassName,
    floatLabelId = _ref.floatLabelId,
    floatLabelText = _ref.floatLabelText,
    hintText = _ref.hintText,
    hintTextId = _ref.hintTextId,
    secondaryLabel = _ref.secondaryLabel,
    secondaryLabelId = _ref.secondaryLabelId,
    _ref$useInactiveStyle = _ref.useInactiveStyle,
    useInactiveStyle = _ref$useInactiveStyle === void 0 ? false : _ref$useInactiveStyle,
    validationId = _ref.validationId,
    visualStyle = _ref.visualStyle;
  var baseFieldRef = (0, _react.useRef)(null);
  var classList = (0, _classnames["default"])('sb-fieldBase overflow-hidden', _defineProperty(_defineProperty(_defineProperty({}, className, Boolean(className)), 'sb-fieldBase--isInvalid', error), "pb0", error));
  return /*#__PURE__*/_react["default"].createElement(_ripple["default"], {
    backgroundClassName: "bg-greenLight",
    className: "sb-fieldBase__ripple",
    containerRef: baseFieldRef
  }, function (_ref2) {
    var ripple = _ref2.ripple,
      eventHandlers = _ref2.eventHandlers;
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: classList
    }, containerProps, eventHandlers, {
      ref: baseFieldRef
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('sb-fieldBase__childWrapper flex items-center', childWrapperClassName, {
        'sb-fieldBase__childWrapper--greenStyle': visualStyle === 'green',
        'sb-fieldBase__childWrapper--Inactive': useInactiveStyle
      })
    }, floatLabelText ? /*#__PURE__*/_react["default"].createElement(_floatLabel["default"], _extends({
      active: floatLabelActive,
      activeText: floatLabelActiveText,
      "aria-hidden": floatLabelAriaHidden,
      className: (0, _classnames["default"])(floatLabelClassName, {
        'color-red': error
      }),
      htmlFor: childId,
      id: floatLabelId,
      showErrorState: error,
      useInactiveStyle: useInactiveStyle,
      visualStyle: visualStyle
    }, eventHandlers), floatLabelText) : null, secondaryLabel && floatLabelActive ? /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('sb-fieldBase__secondaryLabel bg-white borderRadius-xs px1', {
        'color-greenAccent': !error,
        'color-red': error
      }),
      id: secondaryLabelId
    }, secondaryLabel) : null, children, ripple), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pl3"
    }, enableValidationMessage ? /*#__PURE__*/_react["default"].createElement(_inputValidationMessage["default"], {
      customFieldStatus: customFieldStatus,
      displayStatus: errorMessageDisplayStatus,
      error: error,
      errorMessage: errorMessage,
      id: validationId
    }) : null, hintText ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('pt2', {
        'sb-fieldBase__hintText--greenStyle': visualStyle === 'green',
        'sb-fieldBase__hintText--inactiveStyle': useInactiveStyle
      }),
      id: hintTextId
    }, /*#__PURE__*/_react["default"].createElement("p", null, hintText)) : null));
  });
};
FieldBase.propTypes = process.env.NODE_ENV !== "production" ? {
  childId: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  childWrapperClassName: _propTypes["default"].string,
  className: _propTypes["default"].string,
  containerProps: _propTypes["default"].object,
  customFieldStatus: _propTypes["default"].bool,
  enableValidationMessage: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  errorMessage: _propTypes["default"].node,
  errorMessageDisplayStatus: _propTypes["default"].bool,
  floatLabelActive: _propTypes["default"].bool,
  floatLabelActiveText: _propTypes["default"].node,
  floatLabelAriaHidden: _propTypes["default"].bool,
  floatLabelClassName: _propTypes["default"].string,
  floatLabelId: _propTypes["default"].string,
  floatLabelText: _propTypes["default"].node,
  hintText: _propTypes["default"].node,
  hintTextId: _propTypes["default"].string,
  useInactiveStyle: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  secondaryLabel: _propTypes["default"].string,
  validationId: _propTypes["default"].string
} : {};
var _default = exports["default"] = FieldBase;